import { gql } from 'graphql-tag';

export default gql`
  query GetUserOpenCreditsTotalAdmin(
    $input: GetUserOpenCreditsTotalAdminInput!
  ) {
    getUserOpenCreditsTotalAdmin(input: $input)
  }
`;
